export function CalendarContainer({ children }: React.PropsWithChildren) {
  return <div className="p-2 rounded-md shadow-md bg-background-surface text-text-base-primary">{children}</div>;
}

export function calendarContainerWithFooter(Footer: React.ComponentType) {
  return function CalendaContainerWithFooter({ children }: React.PropsWithChildren) {
    return (
      <div className="p-2 rounded-md shadow-md bg-background-surface text-text-base-primary flex flex-col">
        {children}
        <div className="flex justify-center mt-2">
          <Footer />
        </div>
      </div>
    );
  };
}
